import { render, staticRenderFns } from "./JobAdditionalInfo.vue?vue&type=template&id=770c11d0"
import script from "./JobAdditionalInfo.vue?vue&type=script&lang=js"
export * from "./JobAdditionalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports